<!-- 单个玩家沟通页 -->
<template>
  <div class="game-1">
    <nf-card borderInnerSize="0" round=".2rem">
      <div style="color: #555">我最新轮的选择：</div>
      <div class="game-1-box" v-if="currentCardList.length > 0">
        <!-- <div class="game-1-box-title">当前：第1/8页</div> -->
        <div
          class="game-1-box-list"
          v-if="gameInfo.visibleType != 'wheel'"
          :class="{ 'brand-text': flip }"
        >
          <!-- 左右滑动，一个Swipeitem中有8张图片，一行4个 -->
          <Grid :column-num="3" :border="false" :clickable="false">
            <GridItem
              v-for="(subitem, subindex) in currentCardList"
              @click.native="cardBrandHandle(subitem)"
              :key="subindex"
            >
              <NfBrand
                trigger="custom"
                height="2.85rem"
                :onlyKey="`brand-${subindex}`"
                v-model="subitem.brandStatus"
              >
                <template #cz>
                  <VanImage
                    height="100%"
                    :src="
                      subitem.isFront != 1
                        ? subitem.reverseImg
                        : subitem.frontImg
                    "
                    fit="cover"
                    radius="5"
                  />
                </template>
                <template #cf>
                  <VanImage
                    height="100%"
                    :src="
                      subitem.isFront != 1
                        ? subitem.frontImg
                        : subitem.reverseImg
                    "
                    fit="cover"
                    radius="5"
                  />
                </template>

                <div
                  class="game-1-box-list-open"
                  @click.stop="previewImgHandle(subitem)"
                >
                  <Icon name="search" size="0.3rem" />
                </div>
                <!-- <div class="game-1-box-list-tip">单击可翻面</div> -->
              </NfBrand>
            </GridItem>
          </Grid>

          <!-- 如果列表为空的显示 -->
          <div
            v-if="
              formValue.playerCardList[formValue.roleTab].length == 0 &&
              gameStaus == 2
            "
          >
            <Empty description="用户最新轮未抽取卡牌" />
          </div>
          <NfButton
            v-show="flip"
            color="rgb(255,211,94)"
            round=".5rem"
            style="margin-top: 0.2rem"
            @click.native="brandHandle"
            >翻面</NfButton
          >
        </div>
        <div class="game-1-box-list" v-else>
          <!-- <div v-else> -->

          <WheelRecord
            :value="formValue.playerCardList[formValue.roleTab]"
            width="380px"
            height="380px"
          />
        </div>
      </div>
      <div class="game-1-box" v-else>
        <div class="game-1-box-list-empty">
          <Empty description="用户还未打分" />
        </div>
      </div>
    </nf-card>
  </div>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import {
  Swipe,
  SwipeItem,
  Image as VanImage,
  Grid,
  GridItem,
  Empty,
  Icon,
  ImagePreview,
} from "vant";
import NfButton from "@/components/game-ui/NfButton.vue";
import NfBrand from "@/components/game-ui/NfBrand.vue";
import WheelRecord from "@/components/game-comm/WheelRecord.vue";

export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
    flip: {
      type: Boolean,
      default: false,
    },
    gameStaus: {
      type: Number,
      default: 1,
    },
    gameInfo: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
  },
  data() {
    return {
      list: [
        {
          img: "https://img01.yzcdn.cn/vant/cat.jpeg",
        },
        {
          img: "https://img01.yzcdn.cn/vant/cat.jpeg",
        },
        {
          img: "https://img01.yzcdn.cn/vant/cat.jpeg",
        },
        {
          img: "https://img01.yzcdn.cn/vant/cat.jpeg",
        },
        {
          img: "https://img01.yzcdn.cn/vant/cat.jpeg",
        },
        {
          img: "https://img01.yzcdn.cn/vant/cat.jpeg",
        },
      ],
      // 翻面状态
      brandStatus: false,
      currentCardList: [],
    };
  },
  components: {
    NfCard,
    Empty,
    NfButton,
    Swipe,
    SwipeItem,
    VanImage,
    Grid,
    GridItem,
    NfBrand,
    WheelRecord,
    Icon,
    ImagePreview,
  },
  methods: {
    brandHandle() {
      // this.brandStatus = !this.brandStatus;
      // 遍历列表，将所有的brandStatus取反
      this.currentCardList.forEach((item) => {
        item.brandStatus = !item.brandStatus;
      });
    },
    cardBrandHandle(item) {
      console.log(item, this.flip, item.brandStatus);
      if (!this.flip) {
        return;
      }
      console.log("开始改变");
      item.brandStatus = !item.brandStatus;
    },
    previewImgHandle(item) {
      const img = item.brandStatus ? item.reverseImg : item.frontImg;
      ImagePreview({
        images: [img],
      });
    },
  },
  computed: {
    formValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", {
          ...val,
        });
      },
    },
    // currentCardList() {
    //   return this.value.playerCardList[this.value.roleTab].map((item) => {
    //     return {
    //       ...item,
    //       brandStatus: false,
    //     };
    //   });
    // },
  },
  watch: {
    "value.playerCardList": {
      handler(val) {
        console.log("diacus watch");
        this.currentCardList = this.value.playerCardList[
          this.value.roleTab
        ].map((item) => {
          return {
            ...item,
            brandStatus: false,
          };
        });
      },
      deep: true,
      immediate: true,
    },
    "value.roleTab": {
      handler(val) {
        console.log("diacus watch");
        this.currentCardList = this.value.playerCardList[
          this.value.roleTab
        ].map((item) => {
          return {
            ...item,
            brandStatus: false,
          };
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.game-1 {
  color: #666;
  &-box {
    &-title {
      text-align: center;
    }

    &-list {
      position: relative;
      ::v-deep .van-grid-item__content {
        padding: 0.1rem;
      }

      &-divider {
        // 虚线
        border-top: 1px dashed #666;
        margin: 0.3rem 0;
      }

      &-select {
        &-btns {
          display: flex;
          justify-content: space-between;
          margin-top: 0.2rem;
          &-btn {
            margin: 0 0.2rem;
          }
        }
      }

      &-tip {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.5);
      }

      &-open {
        position: absolute;
        top: -0.15rem;
        right: -0.15rem;
        border-radius: 50%;
        width: 0.6rem;
        height: 0.6rem;
        background: #eee;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &-step {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;

      &-left {
      }
      &-right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        &-item {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          margin: 0.1rem 0;
          &-text {
            font-size: 0.25rem;
          }
          &-icon {
          }
        }
      }
    }
  }
}

.brand-text {
  ::v-deep .van-image {
    // 底部增加单击可翻面的提示
    position: relative;
    &::after {
      content: "单击可翻面";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 0.1rem 0;
      text-align: center;
      color: #fff;
      font-size: 0.2rem;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}

::v-deep .van-grid {
  justify-content: center;
}
</style>

<style lang="scss"></style>
